import { types, Instance } from 'mobx-state-tree';

export const TableCell = types.model({
  key: types.identifier,
  value: types.maybe(types.string),
  sheetHeader: types.string,
  columnIdx: types.number,
  rowIdx: types.number,
  type: types.string,
});

export type ITableCell = Instance<typeof TableCell>;
